import { Pipe, PipeTransform } from "@angular/core";
import { formatDate } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "convTimeFormat",
})
export class ConversationTimeFormatPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  transform(date: any): string {
    const convDate = new Date(Date.parse(date));
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    if (this.isSameDay(convDate, now)) {
      return formatDate(convDate, "h:mm a", "en-US");
    } else if (this.isSameDay(convDate, yesterday)) {
      return this.translateService.instant("ANALYTICS.PAGE.YESTERDAY");
    } else {
      return formatDate(convDate, "dd/MM/yy", "en-US");
    }
  }

  private isSameDay(date1: Date, date2: Date): boolean {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  }
}
